import AssignmentIcon from '@mui/icons-material/Assignment';

const icons = {
  AssignmentIcon
};

const RegisteredCases = {
  id: 'RegisteredCases',
  type: 'group',
  children: [
    {
      id: 'RegisteredCases',
      title: 'All Claims',
      type: 'item',
      url: '/All-registered-Cases',
      icon: icons.AssignmentIcon,
    }
  ]
};

export default RegisteredCases;
